import { Component, OnInit } from '@angular/core';
import { Globals } from '../_globals';

@Component({
    selector: 'app-restricted',
    templateUrl: './restricted.component.html',
    styleUrls: ['./restricted.component.css']
})
export class RestrictedComponent implements OnInit {

    constructor(
        public globals: Globals
    ) { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/restricted/restricted.component.ts